import React from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { IPage } from "../../../interfaces/models/models/paginated-response.model";
import Table from "../../../shared/table";
import { IGuests } from "../../../interfaces/guests/IGuests";

const tableColumns = [
  "Cabin",
  "Guest",
  "Summary",
  "Links",
  "Actions",
];

interface IGuestsTable {
  rows: IGuests[];
  paginationData?: IPage;
  rowsLoading: boolean;
  onClickDetails: (id: string) => void;
  setPaginationState: ({ pageNumber, pageSize }: IPaginationPayload) => void;
}

const GuestsTable = ({
  rows,
  paginationData,
  rowsLoading,
  onClickDetails,
  setPaginationState,
}: IGuestsTable) => {
  return (
    <div className="border rounded-2xl border-gray-200 my-3">
      <Table
        columns={tableColumns}
        paginationData={paginationData}
        setPaginationState={setPaginationState}
        headStyle={"!bg-transparent"}
        headerColsStyle={"!text-gray-500 !font-semibold !font-sm"}
        containerStyle={"!my-0"}
      >
        {rowsLoading ? (
          <>
            {[...Array(4)].map((x, i) => {
              return (
                <tr key={i}>
                  {[...Array(tableColumns?.length || 1)].map((x, j) => {
                    return (
                      <td
                        key={j}
                        className="td-1 !min-w-[100%] text-center py-5"
                      >
                        <span></span>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </>
        ) : (
          <>
            {rows?.length > 0 &&
              rows?.map((row, idx: number) => {
                return (
                  <tr
                    key={idx}
                    className="bg-white border-b hover:bg-gray-50 cursor-pointer"
                    onClick={() =>
                      onClickDetails(row._id)
                    }
                  >
                    <td className="px-6 py-4 text-gray-600">{row?.bookings[0].room}</td>
                    <td className="px-6 py-4 text-gray-600">
                      {row?.fullName}
                    </td>
                    <td className="px-6 py-4 text-gray-600 text-xs">{row?.summary}</td>
                    <td className="px-6 py-4 text-gray-600">
						<div className="flex flex-row">
						{row.socialLinks?.map(link => <a rel="noreferrer" href={link.link} target="_blank" className="mx-0.5 w-6">
						{['instagram', 'facebook', 'twitter', 'linkedin', 'youtube', 'website', 'linktree'].includes(link.socialMedia) ?
							<img alt={link.socialMedia} className="w-6 h-6 object-contain" src={`/svg/icons/${link.socialMedia}.svg`} /> :
							link.socialMedia
			  			}
					  </a>)}
						</div>
                      
                    </td>
                    <td
                      className={`px-6 py-4`}
                    >
                      <img src='/svg/layout/more.svg' />
                    </td>
                  </tr>
                );
              })}
          </>
        )}
      </Table>
    </div>
  );
};

export default GuestsTable;
